import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { EnvService } from '@src/app/modules/env';
import { MetrikaService } from '@src/app/modules/metrika';

@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private readonly router = inject(Router);
  private readonly env = inject(EnvService);
  private readonly metrikaService = inject(MetrikaService);

  private historyUrl: string[] = [];

  init() {
    this.historyUrl.push(this.router.url);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        const previousUrl = this.historyUrl[this.historyUrl.length - 1];
        if (currentUrl !== previousUrl) {
          this.historyUrl.push(currentUrl);
          this.metrikaService.check();
        }
      }
    });
  }

  back(defaultUrl: string) {
    if (this.env.isCordova) {
      this.historyUrl.pop();
      const previousUrl = this.historyUrl[this.historyUrl.length - 1];
      const newUrl = previousUrl && previousUrl !== '/' ? previousUrl : defaultUrl;

      if (window.history.length > 1) {
        window.history.go(-1);
      } else {
        this.router.navigateByUrl(newUrl, { skipLocationChange: true });
      }
    } else if (window.history.length > 1) {
      window.history.go(-1);
    } else {
      this.router.navigateByUrl(defaultUrl);
    }
  }
}
